<template>
  <div class="rt-card col-xs-4 col-sm-4 col-md-3 col-lg-2 col-xl-1 w100">
    <pl-card @click.stop.native="goToEditPremade(premade.type)">
      <div class="inner-card">
        <section class="rt-type-container">
          <div
            v-if="premade.type === 'live'"
            class="row middle-xs center-xs live-rt"
          >
            <img width="26px" height="24px" src="static/logos/live.svg" />
            <span> Verbal </span>
          </div>
          <div
            v-else-if="premade.type === 'online'"
            class="row middle-xs center-xs online-rt"
          >
            <img width="26px" height="24px" src="static/logos/online.svg" />
            <span> Written </span>
          </div>
        </section>
        <div class="row center-xs middle-xs card-image-container">
          <pl-preloader :src="get_thumbnail_on_amazon_aws" class="card-image" />
          <div
            v-if="premade.is_certified"
            class="row center-xs middle-xs parlay-certified"
          >
            <img src="static/logos/universe_logo.svg" />
          </div>
          <template v-if="getProfile.role === 'admin'">
            <div
              v-if="premade.accessibility !== 'Public'"
              class="publish-status"
              :class="{ draft: premade_accessibility }"
            >
              <span
                class="pl-subheading"
                style="font-size: 20px; font-weight: bold"
                >{{ premade.accessibility }}</span
              >
            </div>
          </template>
        </div>
        <div
          class="pl-subheading row"
          style="position: relative; min-height: 48px"
        >
          <strong class="col-xs-12 ellipsisTitle">{{ premade.title }}</strong>
        </div>
        <div
          class="pl-subheading row col-xs-12 ellipsisSubjectGrade"
          v-on:mouseover="activeTooltipSubject = true"
          v-on:mouseout="activeTooltipSubject = false"
        >
          <div class="activeTooltip" v-if="activeTooltipSubject">
            <p v-for="subject in premade.subjects" :key="subject.id">
              {{ subject.name }}
            </p>
          </div>
          <template v-for="(subject, i) in premade.subjects">
            {{ subject.name }}{{ i === premade.subjects.length - 1 ? '' : ',' }}
          </template>
        </div>
        <div style="height: 24px">
          <div
            v-if="premade.grade_levels.length > 0"
            class="pl-subheading row col-xs-12 ellipsisSubjectGrade"
            v-on:mouseover="activeTooltipGrade = true"
            v-on:mouseout="activeTooltipGrade = false"
          >
            <div class="activeTooltip" v-if="activeTooltipGrade">
              <p v-for="level in premade.grade_levels" :key="level.id">
                {{ level.grade }}
              </p>
            </div>
            <span
              class="subject_grade_span"
              style="float: left; margin-right: 2px"
            >
              Grades:</span
            >
            <template v-for="(level, i) in sortGrades">
              {{ level }}{{ i === sortGrades.length - 1 ? '' : ',' }}
            </template>
          </div>
        </div>
        <div
          class="pl-subheading row col-xs-12"
          style="margin: 0; border-top: 1px solid #808284"
        ></div>
        <div class="row col-xs-12 author-info">
          <div class="col-xs-9 authorName">
            <img :src="premade_author.avatar_url" />
            <span>{{ premade_author.name }}</span>
          </div>
          <div class="col-xs-3 ml-auto" style="padding: 0; text-align: right">
            <img
              src="/static/replications_icon.svg"
              style="height: 15px; align-self: center"
            />
            <span style="color: #797979; font-weight: normal">
              {{ formatNumber(premade.replications) }}
            </span>
          </div>
        </div>
      </div>
    </pl-card>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import getImageOnS3 from 'services/amazonAWS/getImageOnS3';

  export default {
    // props are passed down from: features/courses/courseDetails/courseDetails.html
    props: {
      premade: {
        type: Object,
        default() {
          return {
            title: 'Activity',
            thumbnail_url: '',
            accessibility: '',
            replications: 0,
          };
        },
      },
    },
    data() {
      return {
        activeTooltipSubject: false,
        activeTooltipGrade: false,
      };
    },
    computed: {
      ...mapGetters(['getProfile']),
      get_thumbnail_on_amazon_aws() {
        if (
          this.premade.thumbnail_url.includes('/static') ||
          this.premade.thumbnail_url.includes('i.vimeocdn')
        )
          return this.premade.thumbnail_url;
        return getImageOnS3(
          '341x192',
          'premade_thumbnails',
          this.premade.thumbnail_url
        );
      },
      premade_accessibility() {
        return this.premade.accessibility == 'Draft';
      },
      premade_author() {
        return (
          this.premade.author || {
            name: 'Parlay',
            avatar_url: '/static/logos/ring.svg',
          }
        );
      },
      premade_subjects() {
        return this.premade.premade_subjects.map((sub) => sub.name);
      },
      sortGrades() {
        const grade = this.premade.grade_levels.map((g) => g.grade);
        return grade.sort((a, b) => {
          if (parseInt(a.split('-')[0]) > parseInt(b.split('-')[0])) return 1;
          else return -1;
        });
      },
    },
    methods: {
      goToEditPremade() {
        let routeData = '';
        if (this.premade.type === 'online') {
          routeData = this.$router.resolve({
            name: 'premade-form',
            params: {
              premadeID: this.premade.id,
            },
            query: {
              editing: true,
            },
          });
          window.open(routeData.href, '_blank');
        } else if (this.premade.type === 'live') {
          routeData = this.$router.resolve({
            name: 'live-premade-form',
            params: {
              premadeID: this.premade.id,
            },
            query: {
              editing: true,
            },
          });
          window.open(routeData.href, '_blank');
        }
      },
      formatNumber(n) {
        const ranges = [
          { divider: 1e18, suffix: 'E' },
          { divider: 1e15, suffix: 'P' },
          { divider: 1e12, suffix: 'T' },
          { divider: 1e9, suffix: 'G' },
          { divider: 1e6, suffix: 'M' },
          { divider: 1e3, suffix: 'k' },
        ];
        for (var i = 0; i < ranges.length; i++) {
          if (n >= ranges[i].divider) {
            return (n / ranges[i].divider).toString() + ranges[i].suffix;
          }
        }
        return n.toString();
      },
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
  .rt-card
    padding: 20px 30px 8px 5px

    .inner-card
      padding-top: 10px
      margin: 0 10px
      .publish-status
        position: absolute;
        background-color: #FFFFFF;
        color: pl-ruby
        padding: 5px 20px
        border-radius: 2px
        font-weight: bold
        &:not(.draft)
          color: black
      .card-image-container
        position: relative
        overflow: hidden
        max-height: 135px
        margin: 0
        &:before
          width: 100%
          // padding-top 56.25% is the same of making ratio 16:9
          padding-top: 56.25%
          display: block
          content: " "
        .card-image
          position: absolute
          top: 50%
          right: 0
          left: 0
          transform: translateY(-50%)
          img
            min-width: 100% !important


  .author-info
    position: relative
    padding: 5px 0
    margin: 0
    img
      width: 23px
      height: 23px
      border-radius: 50%
    span
      line-height: 26px
      font-size: 12px
      color: #273248
      font-weight: bold
  .subject_grade_span
    line-height: 24px
    font-size: 12px
    color: pl-slate

  .ellipsisTitle {
    overflow: hidden
    text-overflow: ellipsis
    display: -webkit-box
    -webkit-line-clamp: 2
    -webkit-box-orient: vertical
  }

  .authorName {
    padding: 0
    overflow: hidden
    text-overflow: ellipsis
    display: -webkit-box
    -webkit-line-clamp: 1
    -webkit-box-orient: vertical
  }

  .ellipsisSubjectGrade {
    display: block
    white-space: nowrap
    width: 100%
    overflow: hidden
    text-overflow: ellipsis
    font-size: 12px !important
    color: pl-slate
    height: 24px
  }

  .activeTooltip
    background-color: #323232;
    color: white;
    position: absolute;
    z-index:1;
    border-radius:8px;
    text-align: left;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 11px;

  .parlay-certified
    position: absolute
    height: 24px
    width: 24px
    background-color: #FFFFFF
    border-radius: 50%
    left: 10px;
    bottom: 7px;
    z-index: 1000; /* to stay on top */
    img
      height: 24px
      width: 24px

  .rt-type-container
    padding: 0px 8px;
    span
      margin-left: 5px
      font-size: 18px
      font-weight: 600
      line-height: 28px
      color: #273248
    .live-rt
      padding: 5px 0px
      background-color: rgba(111,207,107,0.16)
    .online-rt
      padding: 5px 0px
      background-color: #EAF8F9
</style>



// WEBPACK FOOTER //
// searchEditPremadeCard.vue?35780a58